import { ProcessAPI } from '../process';

export function getFieldAPI(fieldId, gridFormParent) {
	const formAPI = getFormAPI();

	return (gridFormParent)
		? formAPI.fields(gridFormParent).fields(fieldId)
		: formAPI.fields(fieldId);
}

export function getFormAPI() {
	return ProcessAPI.currentProcess().form();
}
